import { render, staticRenderFns } from "./TrancheSummary.vue?vue&type=template&id=7f92a104&"
import script from "./TrancheSummary.vue?vue&type=script&lang=js&"
export * from "./TrancheSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports